var render = function render(){var _vm=this,_c=_vm._self._c;return _c('homeItem',{staticClass:"boxMargin",attrs:{"item-title":_vm.descTitle}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.desc)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }